import { FC } from 'react';
import { Route } from 'react-router-dom';
import RouteConstants from '../router/RouteConstants';
import { WhatsappInboxContainer } from './components/WhatsappInboxContainer';

// Plain Route: auth is already guarded by GuardedWhatsappInbox in Layout.routes (withAuthenticationRequired, built once at
// module scope), and a nested PrivateRoute builds a new component type per render, remounting the page on every conversation click.
export const WhatsappInboxRouter: FC = () => <Route path={`${RouteConstants.whatsappInbox}/:conversationId?`} component={WhatsappInboxContainer} />;
